module.exports = __webpack_public_path__ + "static/BikiCoin-5b100a9d3fb112dcb3db4123bb3dd028.png";